<template>
  <div v-if="item.video_desktop || item.video_mobile">
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div v-if="!loading && item.video_desktop">
        <div class="video-item">
          <video
            class="video"
            height="100%"
            width="100%"
            autoplay
            muted
            loop
            :src="
              !xs
                ? files + item.video_desktop
                : item.video_mobile
                ? files + item.video_mobile
                : files + item.video_desktop
            "
          ></video>

          <div
            class="
              video-item-caption
              d-flex
              flex-column
              white--text
              text-uppercase
            "
          >
            <span>{{ titleWhite }}</span>
            <span
              class="font-italic font-weight-bold primary--text text--lighten-1"
              >{{ titleBlue }}</span
            >
          </div>
          <div class="progress-bar"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";

const _config = {
  mod: "video-top",
};

export default {
  data: () => ({
    loading: true,
    progressBarDuration: 0,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    titleWhite() {
      return this.item.title ? this.item.title.split("<br>")[0] : ``;
    },
    titleBlue() {
      return this.item.title ? this.item.title.split("<br>")[1] : ``;
    },

    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false))
      .then(() => {
        this.getProgressBarDuration(document.querySelector(".video"));
      });
  },
  methods: {
    getProgressBarDuration(video) {
      var i = setInterval(function () {
        if (video.readyState > 0) {
          const progressBar = document.querySelector(".progress-bar");
          progressBar.style.animation = `progressAnimation linear infinite ${
            video.duration % 60
          }s`;
          clearInterval(i);
        }
      }, 200);
    },
  },
  components: {
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.video-item {
  position: relative;
  & video {
    display: block;
    aspect-ratio: 1920/664;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;
    @media (max-width: 600px) {
      aspect-ratio: 600/600;
    }
  }
  &-caption {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    & span {
      font-size: 60px;
      @media (max-width: 1100px) {
        font-size: 50px;
      }
      @media (max-width: 960px) {
        font-size: 40px;
      }
      @media (max-width: 600px) {
        font-size: 20px;
      }
    }
  }
}
</style>

<style>
.progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 5px;
  width: 0%;
  background-color: rgba(255, 255, 255, 0.7);
}
@keyframes progressAnimation {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
</style>
